import { UseMicroserviceShowVariant } from "@with-nx/hooks-n-helpers";
import { useServerRegion } from "@with-nx/region";
import { DesignedTab } from "@with-nx/simple-ui/atoms";
import { useRouter } from "next/router";
import { FC } from "react";

interface ShowsTabProps {
  loading: boolean;
  empty: boolean;
  showVariant?: UseMicroserviceShowVariant;
  onlyShow?: boolean;
  currentTab: string;
  waitlist?: boolean;
}

export const ShowsTab: FC<ShowsTabProps> = ({
  loading,
  empty,
  showVariant,
  onlyShow,
  currentTab,
}) => {
  const router = useRouter();
  const region = useServerRegion();

  const handleTabPress = (tab) => {
    switch (tab) {
      case "Overview":
        router.push(`/shows/${router.query?.brand}/${router.query?.variant}`);
        break;

      case "Scenic Projections":
      case "Scenic Projections (Coming Soon)":
        router.push(
          `/shows/${router.query?.brand}/${router.query?.variant}/scenic-projections`
        );
        break;

      case "Backdrop Library":
        router.push(
          `/shows/${router.query?.brand}/${router.query?.variant}/backdrop-library`
        );
        break;

      case "Choreography Guides":
        router.push(
          `/shows/${router.query?.brand}/${router.query?.variant}/choreography-guides`
        );

        break;
      case "Stage Guides":
        router.push(
          `/shows/${router.query?.brand}/${router.query?.variant}/stage-guides`
        );

        break;
      case "Stage Gear":
        router.push(`/stage-gear`);

        break;
      case "Related Shows":
        router.push(`/shows/${router.query?.brand}`);
        break;
    }
  };

  const tabs = [
    ...(empty ? [] : ["Overview"]),
    "Scenic Projections",
    ...(showVariant?.showBrand?.dropsCount > 0 ? ["Backdrop Library"] : []),
    "Choreography Guides",
    "Stage Guides",
    ...(region.id === 1 ? ["Stage Gear"] : []),
    ...(onlyShow || loading ? [] : ["Related Shows"]),
  ];

  return (
    <DesignedTab
      tabs={tabs}
      tab={currentTab || "Overview"}
      mode="line"
      press={handleTabPress}
    />
  );
};

export default ShowsTab;
